const ReasoningEffortSelectItems = [
    { value: "none", text: "None" },
    { value: "minimal", text: "Minimal" },
    { value: "low", text: "Low" },
    { value: "medium", text: "Medium" },
    { value: "high", text: "High" },
    { value: "xhigh", text: "Extra high" },
    { value: "max", text: "Max" }
];

const Hyphen = '—';

const TimeZoneSelectItems = [
    { label: "UTC", items: [{ value: "UTC" }] },
    ...Object.entries(Intl.supportedValuesOf("timeZone").reduce((groups, timeZone) => {
        const region = timeZone.split("/")[0];
        (groups[region] ??= []).push({ value: timeZone });
        return groups;
    }, {})).map(([label, items]) => ({ label, items }))
];

const VoiceSessionModels = Object.freeze([
    "@openai/gpt-realtime-2.1",
    "@openai/gpt-realtime-2.1-mini"
]);

const VoiceSessionVoices = Object.freeze([
    "marin",
    "cedar",
    "alloy",
    "ash",
    "ballad",
    "coral",
    "echo",
    "sage",
    "shimmer",
    "verse"
]);

const VoiceSessionReasoningEfforts = Object.freeze([
    { value: "minimal", text: "Minimal" },
    { value: "low", text: "Low" },
    { value: "medium", text: "Medium" },
    { value: "high", text: "High" }
]);

const TtsModels = Object.freeze({
    Gpt4oTts: Object.freeze({
        name: "GPT-4o mini TTS",
        price: "~$0.0076/1k chars",
        defaultVoice: "nova",
        voices: Object.freeze([
            "alloy",
            "ash",
            "ballad",
            "coral",
            "echo",
            "fable",
            "onyx",
            "nova",
            "sage",
            "shimmer",
            "verse",
            "marin",
            "cedar"
        ])
    }),
    ElevenMultilingualV2: Object.freeze({
        name: "Eleven Multilingual V2",
        price: "$0.03/1k chars",
        defaultVoice: "alloy",
        voices: Object.freeze(["alloy"]),
        allowCustomVoice: true
    }),
    ElevenV3: Object.freeze({
        name: "Eleven V3",
        price: "$0.03/1k chars",
        defaultVoice: "alloy",
        voices: Object.freeze(["alloy"]),
        allowCustomVoice: true
    }),
    GrokVoice: Object.freeze({
        name: "Grok Voice TTS",
        price: "$15/M chars",
        defaultVoice: "Eve",
        voices: Object.freeze(["Eve", "Ara", "Rex", "Sal", "Leo"])
    }),
    ElevenV4: Object.freeze({
        name: "Eleven V4",
        price: "$0.08/1k chars",
        defaultVoice: "george",
        voices: Object.freeze(["george", "sarah", "adam", "alice", "bella", "bill", "brian", "callum", "charlie", "chris", "daniel", "eric", "harry", "jessica", "laura", "liam", "lily", "matilda", "river", "roger", "will"]),
        allowCustomVoice: true
    }),
    ElevenV4Turbo: Object.freeze({
        name: "Eleven V4 Turbo",
        price: "$0.04/1k chars",
        defaultVoice: "george",
        voices: Object.freeze(["george", "sarah", "adam", "alice", "bella", "bill", "brian", "callum", "charlie", "chris", "daniel", "eric", "harry", "jessica", "laura", "liam", "lily", "matilda", "river", "roger", "will"]),
        allowCustomVoice: true
    }),
    VoxtralMiniTts3: Object.freeze({
        name: "Voxtral Mini TTS 3",
        price: "$0.013/1k chars",
        defaultVoice: "voice_3150",
        voices: Object.freeze(["voice_3150", "voice_478", "voice_447", "voice_485", "en_paul_sad", "en_paul_neutral", "en_paul_happy", "en_paul_frustrated", "en_paul_excited", "en_paul_confident", "en_paul_cheerful", "en_paul_angry", "voice_3149", "voice_3147", "voice_591", "voice_590", "voice_1788", "voice_1787", "voice_1786", "gb_oliver_neutral", "gb_jane_sarcasm", "gb_jane_confused", "gb_oliver_sad", "gb_oliver_excited", "gb_oliver_curious", "gb_oliver_confident", "gb_oliver_cheerful", "gb_oliver_angry", "gb_jane_shameful", "gb_jane_sad", "gb_jane_neutral", "gb_jane_jealousy", "gb_jane_frustrated", "gb_jane_curious", "gb_jane_confident", "voice_479", "voice_3143", "voice_481", "voice_483", "voice_592", "voice_3137", "voice_589", "voice_3141", "fr_marie_sad", "fr_marie_neutral", "fr_marie_happy", "fr_marie_excited", "fr_marie_curious", "fr_marie_angry", "voice_3153", "voice_3139", "voice_3146", "voice_482", "voice_3133", "voice_3136", "voice_3135", "voice_3145", "voice_3134", "voice_3154", "voice_480", "voice_3155", "voice_3132", "voice_3138", "voice_3140", "voice_3144", "voice_3142"]),
        allowCustomVoice: true
    }),
    HeygenVoice1Turbo: Object.freeze({
        name: "HeyGen Voice 1 Turbo",
        price: "$0.004/1k chars",
        defaultVoice: "nadine",
        voices: Object.freeze(["nadine", "tabitha", "bram", "gareth", "noelle", "meredith", "sabrina", "lucian", "weston", "vincent"]),
        allowCustomVoice: true
    }),
    HeygenVoice1: Object.freeze({
        name: "HeyGen Voice 1",
        price: "$0.015/1k chars",
        defaultVoice: "nadine",
        voices: Object.freeze(["nadine", "tabitha", "bram", "gareth", "noelle", "meredith", "sabrina", "lucian", "weston", "vincent"]),
        allowCustomVoice: true
    }),
    FishS2_1Pro: Object.freeze({
        name: "Fish Audio S2.1 Pro",
        price: "$0.015/1k chars",
        voices: Object.freeze([]),
        allowCustomVoice: true
    })
});

export const Constants = {

    DefaultAiEditModelName: "@xiaomi/mimo-v2.5-pro",

    TtsModels,

    Hyphen,

    VoiceSessionModels,

    VoiceSessionVoices,

    VoiceSessionReasoningEfforts,

    ReasoningEffortSelectItems,

    TimeZoneSelectItems,

    NullableReasoningEffortSelectItems: [
        { value: null, text: "Default" },
        ...ReasoningEffortSelectItems
    ],

    MultimodalResolverEngines: Object.freeze({
        ImageEngineValues: Object.freeze({
            InferenceLow: "Inference (low effort)",
            InferenceHigh: "Inference (high effort)",
            Ocr: "OCR"
        }),
        AudioEngineValues: Object.freeze({
            InferenceLow: "Inference (low effort)",
            InferenceHigh: "Inference (high effort)",
            Stt: "Speech-to-text"
        }),
        VideoEngineValues: Object.freeze({
            InferenceLow: "Inference (low effort)",
            InferenceHigh: "Inference (high effort)"
        }),
        FileEngineValues: Object.freeze({
            InferenceLow: "Inference (low effort)",
            InferenceHigh: "Inference (high effort)",
            Ocr: "OCR"
        })
    })
};
